import { isObject } from "lodash-es"
import { Empty } from "./utility"
import { SerializedModel } from "./serialized-model"

export type AppError = {
  error: {
    detail: string | Empty
    status: number
    meta: string | Empty
    error_class: string
  }
}

export type ErrorWithUserMessage = AppError & {
  error_class: "ErrorWithUserMessage"
}

export type SerializedModelWithErrors = Required<SerializedModel>

export const isAppError = (error_data: unknown): error_data is AppError => (
  isObject(error_data) &&
  'error' in error_data &&
  isObject(error_data.error) &&
  'detail' in error_data.error &&
  'error_class' in error_data.error
)

export const isErrorWithUserMessage = (error_data: unknown): error_data is ErrorWithUserMessage => (
  isAppError(error_data) && error_data.error.error_class === "ErrorWithUserMessage"
)

export const isSerializedModelWithErrors = (error_data: unknown): error_data is SerializedModelWithErrors => (
  isObject(error_data) &&
  'errors' in error_data &&
  'type' in error_data &&
  'updated_at' in error_data
)

